// extracted by mini-css-extract-plugin
export default {"filesList":"styles_filesList__jTnpo","fileTypesContainer":"styles_fileTypesContainer__Qn-Ob","uploadItem":"styles_uploadItem__1Gwqg","active":"styles_active__fWYpN"};